module.exports = __webpack_public_path__ + "static/img/zt2-pic13.7d97cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt2-pic13.jpg
// module id = kRbZ
// module chunks = 171